import React from 'react'
import PropTypes from 'prop-types'
import { Button, Table } from 'semantic-ui-react'
import { Condition } from 'components/Condition'
import { InitialName } from 'components/InitialName'
import { getHistory } from 'libs/history'

import { getCustomerNameOrEmail, getRemainingCustomerNumber } from './utils'

const CustomerModal = ({
  Modal,
  customerList,
  handleCloseModal,
  header,
  downloadAudienceRulesCSV,
  isDownloading,
}) => {
  const slicedCustomerList = customerList.slice(0, 20)
  return (
    <Modal onClose={handleCloseModal}>
      <Modal.Header>
        {header}
        <Button
          style={{ float: 'right' }}
          onClick={downloadAudienceRulesCSV}
          disabled={isDownloading}
          loading={isDownloading}
        >
          <span>
            <i className="far fa-arrow-to-bottom icon" />
          </span>
          Download CSV
        </Button>
      </Modal.Header>
      <Modal.Content>
        <Table selectable className="compact">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Company</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {slicedCustomerList.map((customer) => (
              <Table.Row
                key={customer.id}
                data-id={customer.id}
                onClick={goToCustomerDetail}
                style={{ cursor: 'pointer' }}
              >
                <Table.Cell>
                  <InitialName name={getCustomerNameOrEmail(customer)} fontSize={1.0} />
                  <span style={{ padding: 8 }}>{getCustomerNameOrEmail(customer)}</span>
                </Table.Cell>
                <Table.Cell>
                  <Condition condition={customer.company}>
                    <Condition.True>
                      <span>{customer.company}</span>
                    </Condition.True>
                    <Condition.False>
                      <span className="text-grey">Unknown</span>
                    </Condition.False>
                  </Condition>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

          <Condition condition={customerList.length !== slicedCustomerList.length}>
            <Condition.True>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    <em>
                      And {getRemainingCustomerNumber(customerList, slicedCustomerList)} other
                      customers like this
                    </em>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Condition.True>
          </Condition>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCloseModal} content="Close" />
      </Modal.Actions>
    </Modal>
  )
}

const goToCustomerDetail = (e) => getHistory().push(`/customers/${e.currentTarget.dataset.id}`)

CustomerModal.propTypes = {
  Modal: PropTypes.any,
  customerList: PropTypes.array,
  handleCloseModal: PropTypes.func,
  header: PropTypes.string,
}

export { CustomerModal }



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerModal/index.js